import jQuery from 'jquery';
import './slick.min.js';

(function($) {
    'use strict';

    // Helper to get uploads URL directory
    const getUploadsBaseUrl = () => {
        const pathSegments = window.location.pathname.split('/').filter(Boolean);
        if (window.location.hostname === 'localhost' && pathSegments.length > 0) {
            return `${window.location.origin}/${pathSegments[0]}/wp-content/uploads/recipes-search-index.json`;
        }
        return '/wp-content/uploads/recipes-search-index.json';
    };

    const initCarouselBlockEngines = () => {
        const carousels = $('.slick-carousel-track-root');
        const inputs = $('.autocomplete-search-input');

        // Initialize Slick Carousels
        carousels.each(function() {
            const $this = $(this);
            if ($this.hasClass('slick-initialized')) return;

            const columnsToShow = parseInt($this.data('columns'), 10) || 3;

            if (typeof $.fn.slick !== 'undefined') {
                $this.slick({
                    infinite: true,
                    slidesToShow: columnsToShow,
                    slidesToScroll: 1,
                    autoplay: false,
                    arrows: true,
                    dots: false,
                    centerMode: false, 
                    variableWidth: false,
                    prevArrow: '<button type="button" class="slick-prev carousel-nav-arrow" style="display:flex !important;" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
                    nextArrow: '<button type="button" class="slick-next carousel-nav-arrow" style="display:flex !important;" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
                    responsive: [
                        { breakpoint: 992, settings: { slidesToShow: 2 } },
                        { breakpoint: 600, settings: { slidesToShow: 1 } }
                    ]
                });
                $this.css({ 'visibility': 'visible', 'display': 'block' });
            } else {
                $this.css({ 'visibility': 'visible', 'display': 'block' });
            }
        });

        // Fast Static File Search Engine (Unlimited Results)
        inputs.each(function() {
            const $input = $(this);
            const $dropdown = $input.siblings('.autocomplete-results-dropdown');
            const categoryId = parseInt($input.data('category'), 10) || 0;
            let preloadedPosts = null;

            $input.parent().css('position', 'relative');
            
            // Set scrollable dropdown bounds so unlimited items render smoothly
            $dropdown.css({ 
                'max-height': '400px', 
                'overflow-y': 'auto',
                'z-index': '999'
            });

            if ($input.siblings('.search-loading-spinner').length === 0) {
                $input.after(`
                    <div class="search-loading-spinner" style="display: none; position: absolute; right: 35px; bottom: 17px; width: 20px; height: 20px; border: 3px solid #f3f3f3; border-top: 3px solid #3E5B25; border-radius: 50%; animation: searchSpin 0.8s linear infinite; z-index: 5;"></div>
                    <style>
                        @keyframes searchSpin { 0% { transform: translateY(-50%) rotate(0deg); } 100% { transform: translateY(-50%) rotate(360deg); } }
                    </style>
                `);
            }
            const $spinner = $input.siblings('.search-loading-spinner');

            // Pre-fetch static JSON file in background
            const preloadStaticIndex = () => {
                if (preloadedPosts !== null) return;

                const cachedData = sessionStorage.getItem('recipes_static_search_index');
                if (cachedData) {
                    try {
                        preloadedPosts = JSON.parse(cachedData);
                        return;
                    } catch (e) {
                        sessionStorage.removeItem('recipes_static_search_index');
                    }
                }

                const jsonUrl = getUploadsBaseUrl();

                fetch(jsonUrl)
                    .then(res => res.ok ? res.json() : [])
                    .then(data => {
                        if (Array.isArray(data) && data.length > 0) {
                            preloadedPosts = data;
                            sessionStorage.setItem('recipes_static_search_index', JSON.stringify(data));
                        }
                    })
                    .catch(() => { preloadedPosts = []; });
            };

            $input.on('focus click', preloadStaticIndex);

            // Render ALL matching dropdown links
            const renderResults = (posts) => {
                $dropdown.empty();
                $spinner.hide();

                if (!posts || posts.length === 0) {
                    $dropdown.append('<div class="autocomplete-no-results" style="padding: 12px 16px; color: #666; font-size: 14px;">No matching articles found.</div>').show();
                    return;
                }

                // Render all matching results
                posts.forEach(post => {
                    $dropdown.append(`<a class="autocomplete-link-node" href="${post.link}">${post.title}</a>`);
                });
                $dropdown.show();
            };

            // Input Event Listener — Instant in-memory search across all recipes
            $input.on('input', function() {
                const searchTerm = $input.val().trim().toLowerCase();

                if (searchTerm.length < 2) {
                    $dropdown.hide().empty();
                    $spinner.hide();
                    return;
                }

                if (preloadedPosts && preloadedPosts.length > 0) {
                    const matches = preloadedPosts.filter(post => {
                        const searchHaystack = post.search || post.title.toLowerCase();
                        const matchesKeyword = searchHaystack.includes(searchTerm);
                        
                        const matchesCategory = categoryId > 0 
                            ? (post.cats && post.cats.includes(categoryId)) 
                            : true;

                        return matchesKeyword && matchesCategory;
                    });

                    renderResults(matches);
                } else {
                    $spinner.show();
                    setTimeout(() => {
                        if (preloadedPosts && preloadedPosts.length > 0) {
                            $input.trigger('input');
                        } else {
                            $spinner.hide();
                        }
                    }, 300);
                }
            });

            $input.off('keydown');
        });

        // Keyboard Navigation
        $(document).off('keydown', '.autocomplete-search-input').on('keydown', '.autocomplete-search-input', function(e) {
            const keysToIntercept = ['ArrowDown', 'ArrowUp', 'Enter', 'Escape'];
            if (!keysToIntercept.includes(e.key)) return;

            const $input = $(this);
            const $dropdown = $input.siblings('.autocomplete-results-dropdown');
            const $links = $dropdown.find('.autocomplete-link-node');
            
            if (!$dropdown.is(':visible') || !$links.length) return;

            e.stopImmediatePropagation();

            let $currentActive = $dropdown.find('.autocomplete-link-node.is-active-highlight');
            let currentIndex = $links.index($currentActive);

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                $links.removeClass('is-active-highlight');
                if (currentIndex === -1 || currentIndex === $links.length - 1) {
                    $links.first().addClass('is-active-highlight');
                } else {
                    $links.eq(currentIndex + 1).addClass('is-active-highlight');
                }
            } 
            else if (e.key === 'ArrowUp') {
                e.preventDefault();
                $links.removeClass('is-active-highlight');
                if (currentIndex === -1 || currentIndex === 0) {
                    $links.last().addClass('is-active-highlight');
                } else {
                    $links.eq(currentIndex - 1).addClass('is-active-highlight');
                }
            } 
            else if (e.key === 'Enter') {
                if ($currentActive.length) {
                    e.preventDefault();
                    window.location.href = $currentActive.attr('href');
                }
            }
            else if (e.key === 'Escape') {
                $dropdown.hide();
            }
        });

        $(document).on('click', function(e) {
            if (!$(e.target).closest('.carousel-autocomplete-search-wrapper').length) {
                $('.autocomplete-results-dropdown').hide();
            }
        });
    };

    $(function() {
        initCarouselBlockEngines();
    });

})(window.jQuery || jQuery);